/**
 * Platform detection for keyboard-hint display. ⌘ on mac, Ctrl elsewhere.
 * (Keybindings themselves accept both via event.metaKey || event.ctrlKey.)
 */

const IS_MAC =
  typeof navigator !== "undefined" &&
  /mac|iphone|ipad|ipod/i.test(navigator.userAgent);

export const modKey = IS_MAC ? "⌘" : "Ctrl";
